// Class: starling.errors.AbstractMethodError

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}

// Constructor

var AbstractMethodError = function(message,id) {
	if(id == null) {
		id = 0;
	}
	if(message == null) {
		message = "Method needs to be implemented in subclass";
	}
	(openfl_errors_Error().default).call(this,message,id);
}

// Meta

AbstractMethodError.__name__ = ["starling","errors","AbstractMethodError"];
AbstractMethodError.__super__ = (openfl_errors_Error().default);
AbstractMethodError.prototype = $extend((openfl_errors_Error().default).prototype, {
	
});
AbstractMethodError.prototype.__class__ = AbstractMethodError.prototype.constructor = $hxClasses["starling.errors.AbstractMethodError"] = AbstractMethodError;

// Init



// Statics




// Export

exports.default = AbstractMethodError;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/errors/AbstractMethodError.js
// module id = 74
// module chunks = 0